// extracted by mini-css-extract-plugin
export var dropdownButton = "_2o-0";
export var fullWidthDropdownButton = "_2o-1";
export var icon = "_2o-3";
export var iconPlaceholder = "_2o-2";
export var menuItemRow = "_2o-9";
export var separator = "_2o-e";
export var shortcutContainer = "_2o-7";
export var shortcutContainerFilled = "_2o-8";
export var shortcutIconLg = "_2o-6";
export var shortcutIconMd = "_2o-5";
export var shortcutIconSm = "_2o-4";
export var submenuChevron = "_2o-d";
export var submenuDropdown = "_2o-a";
export var submenuTriggerRow = "_2o-b";
export var submenuTriggerRowOpen = "_2o-c";